var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#6D6D6C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26,87.1 27.7,87.2 29,87.7 30.5,88.6 31.5,89.7 32.3,91 32.8,92.5 33,94 33,108.5 75.2,134.8  117,108.5 117,94.2 117.2,92.5 117.7,91 118.5,89.7 119.7,88.6 121,87.7 122.5,87.2 124.1,87.1 125.6,87.2 127.1,87.7 128.4,88.6  129.4,89.7 130.4,91 130.9,92.5 131.1,94.2 131.1,112.3 130.9,113.8 130.4,115.1 129.8,116.5 128.9,117.5 127.8,118.4 79,149  77.8,149.5 76.6,149.8 75.3,150 74,149.8 72.9,149.5 71.5,149 22.4,118.4 21.2,117.5 20.2,116.5 19.6,115.1 19.1,113.8 19.1,112.3  19.1,94 19.2,92.5 19.7,91 20.6,89.7 21.7,88.6 22.9,87.7 24.4,87.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,0l3.1,0.2l3,0.7l2.8,0.8l2.7,1.2l2.5,1.7l2.3,1.7l2,2.1l1.8,2.3l1.5,2.3l1.2,2.8l1,2.8l0.5,3l0.1,3 l-0.1,3.1l-0.5,3l-1,2.8L96.7,36l-1.5,2.5l-1.8,2.3l-2,2l-2.3,1.8l-2.5,1.5l-2.7,1.2l-2.8,1l-3,0.5L75,48.9l-3-0.2l-3-0.5l-2.8-1 l-2.8-1.2l-2.3-1.5l-2.3-1.8l-2.1-2L55,38.5L53.3,36l-1.2-2.6l-0.8-2.8l-0.7-3l-0.1-3.1l0.1-3l0.7-3l0.8-2.8l1.2-2.8l1.6-2.3 l1.7-2.3l2.1-2.1l2.3-1.7l2.3-1.7l2.8-1.2l2.8-0.8l3-0.7L75,0z M75,14l-2,0.2l-2,0.5l-1.8,1.1L67.7,17l-1.3,1.6l-1,1.8l-0.7,1.8 l-0.2,2.2l0.2,2.1l0.7,2l1,1.6l1.3,1.6l1.5,1.3l1.8,1l2,0.7l2,0.1l2.2-0.1l2-0.7l1.7-1l1.6-1.3l1.3-1.6l1-1.6l0.7-2l0.2-2.1 l-0.2-2.2l-0.7-1.8l-1-1.8L82.4,17l-1.6-1.2l-1.7-1.1l-2-0.5L75,14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 35,
    className: "st0",
    width: 13.9,
    height: 105.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.4,80.1 36.4,80.1 38.1,80.3 39.6,80.8 40.8,81.6 41.9,82.8 42.7,83.9 43.2,85.4 43.4,87.1  43.2,88.7 42.7,90.2 41.9,91.5 40.8,92.5 39.6,93.3 38.1,93.8 36.4,94 15.4,94 13.8,93.8 12.3,93.3 11.1,92.5 10,91.5 9.1,90.2  8.7,88.7 8.5,87.1 8.7,85.4 9.1,83.9 10,82.8 11.1,81.6 12.3,80.8 13.8,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "113.4,80.1 134.6,80.1 136.1,80.3 137.5,80.8 138.9,81.6 140,82.8 140.7,83.9 141.3,85.4 141.5,87.1  141.3,88.7 140.7,90.2 140,91.5 138.9,92.5 137.5,93.3 136.1,93.8 134.6,94 113.4,94 111.9,93.8 110.4,93.3 109.1,92.5 108.1,91.5  107.3,90.2 106.6,88.7 106.4,87.1 106.6,85.4 107.3,83.9 108.1,82.8 109.1,81.6 110.4,80.8 111.9,80.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.5,57.2 92.5,57.2 94.2,57.3 95.7,57.8 96.8,58.6 98,59.8 98.8,60.9 99.3,62.4 99.5,64.1 99.3,65.7  98.8,67.1 98,68.6 96.8,69.6 95.7,70.4 94.2,70.9 92.5,71 57.5,71 56,70.9 54.5,70.4 53.2,69.6 52.2,68.6 51.3,67.1 50.7,65.7  50.5,64.1 50.7,62.4 51.3,60.9 52.2,59.8 53.2,58.6 54.5,57.8 56,57.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarine);
export default __webpack_public_path__ + "static/media/marine.dd28558d5ec81b4e5490aad80990d4f3.svg";
export { ForwardRef as ReactComponent };